import React from "react";
import classNames from "classnames";
import { SectionTilesProps } from "../../../utils/SectionProps";
import ProjectContent from "../../layout/partials/ProjectContent";
import { projects } from "../../../data/projects";

const propTypes = {
  ...SectionTilesProps.types,
};

const defaultProps = {
  ...SectionTilesProps.defaults,
};

// Listing cards need plain prose. For "html" projects the upperDetail is
// markup, so use the explicit `excerpt` or fall back to a tag-stripped,
// truncated version. Plain-text projects render their upperDetail unchanged.
const cardExcerpt = (project, n = 220) => {
  if (project.contentFormat !== "html") return project.upperDetail;
  if (project.excerpt) return project.excerpt;
  const text = (project.upperDetail || "")
    .replace(/<[^>]*>/g, " ")
    .replace(/\s+/g, " ")
    .trim();
  if (!text) return null;
  return text.length > n ? `${text.slice(0, n - 1).trimEnd()}…` : text;
};

const OurProject = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  ...props
}) => {
  const outerClasses = classNames(
    "features-tiles section",
    topOuterDivider && "has-top-divider",
    bottomOuterDivider && "has-bottom-divider",
    hasBgColor && "has-bg-color",
    invertColor && "invert-color",
    className
  );

  const innerClasses = classNames(
    "testimonial-inner section-inner",
    topDivider && "has-top-divider",
    bottomDivider && "has-bottom-divider"
  );

  const tilesClasses = classNames("tiles-wrap");

  return (
    <section {...props} className={outerClasses}>
      <div className="container">
        <div className={innerClasses}>
          <div className={tilesClasses}>
            {projects.map((project) => {
              const excerpt = cardExcerpt(project);
              return (
                <ProjectContent
                  key={project.id}
                  id={project.id}
                  projectId={project.id}
                  projectName={project.name}
                  projectImg={project.image}
                  projectLogoImg={project.logoImage}
                  tagNames={project.tags}
                  upperDetail={
                    excerpt ? <p className="m-0 p-0">{excerpt}</p> : null
                  }
                  lowerDetail={
                    project.contentFormat !== "html" && project.lowerDetail ? (
                      <p className="m-0 p-0">{project.lowerDetail}</p>
                    ) : null
                  }
                  projectOwner={project.projectOwner}
                  projectDetailLink={`/our-works/${project.id}`}
                />
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

OurProject.propTypes = propTypes;
OurProject.defaultProps = defaultProps;

export default OurProject;
